import React from 'react'
import * as T from '../../../components/Table'
import { Flex, Skeleton } from '@chakra-ui/react'

export function CidadeItemSkeleton() {
  return (
    <T.Tr>
      <T.Td textAlign="start" px={2} py="1" borderRight="1px solid #378BBF!important">
        <Skeleton height="20px" width="80%" />
      </T.Td>
      <T.Td py="1" w="250px" borderRight="1px solid #378BBF!important">
        <Skeleton height="20px" width="90%" />
      </T.Td>
      <T.Td py="1" w="100px" borderRight="1px solid #378BBF!important">
        <Flex flexDir="column" alignItems="center">
          <Skeleton height="20px" width="90%" mb={1} />
          <Skeleton height="20px" width="60%" />
        </Flex>
      </T.Td>
      <T.Td py="1" w="100px" borderRight="1px solid #378BBF!important">
        <Flex alignItems="center" justifyContent="center">
          <Skeleton height="20px" width="80%" />
        </Flex>
      </T.Td>
      <T.Td py="1" w="100px">
        <Flex alignItems="center" justifyContent="center">
          <Skeleton height="20px" width="80%" />
        </Flex>
      </T.Td>
    </T.Tr>
  )
}
